(function ($, Cobalt, undefined) {
	Cobalt.UserTitles =
    {
        initialize: function () {
            $(".j-custom-title").show();
            $(".j-custom-title").addClass('tip');
            $(".j-custom-title").html("<div class='tooltip-html'>Select this option to edit title</div>");

            console.log($(".j-custom-title"));            
            
            if ($(".j-custom-title-radio input[type='radio']").is(':checked')) {
                $(".j-custom-title").removeClass('reduce-opacity');
                $(".j-custom-title").attr('readonly', false);               
              
            } else {
                $(".j-custom-title").addClass('reduce-opacity');
                $(".j-custom-title").attr('readonly', true);               
              
            }
                        
            $(".j-custom-title").attr('placeholder', 'Your awesome title here');
    		$(document).on("change", ".j-title-radio", function () {
    		    Cobalt.UserTitles.handleTitleRadioChange($(this));
    		});
    	},
    	handleTitleRadioChange: function ($titleRadio) {
    	    if ($titleRadio.hasClass("j-custom-title-radio")) {
    	        $(".j-custom-title").show();    	       
    	        $(".j-custom-title").removeClass('reduce-opacity');
    	        $(".j-custom-title").attr('readonly', false);
    	        $(".j-title-radio:not(.j-custom-title-radio) input").prop("checked", false);
    		} else {    	        
    	        $(".j-custom-title").addClass('reduce-opacity');
    	        $(".j-custom-title").attr('readonly', true);
    	        $(".j-custom-title").attr('placeholder', 'Your awesome title here');
    	        $(".j-custom-title-radio input").prop("checked", false);
    	        
    	    }

    	    
    	   
    	}
    };
})(jQuery, Cobalt);



// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.UserTitles.js